import { createContext, useContext } from 'react';

export const FROZEN_SOURCE_ID = 'frozen';

const FrozenPartialMatingsContext = createContext<Map<string, number>>(
  new Map(),
);

export const FrozenPartialMatingsProvider = FrozenPartialMatingsContext.Provider;

export const useFrozenPartialMatings = () =>
  useContext(FrozenPartialMatingsContext);
